import * as Types from '@mildang/graphql-artifact';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FeedRecommendationSubscriptionSubscriptionVariables = Types.Exact<{
  studentId: Types.Scalars['ID']['input'];
}>;


export type FeedRecommendationSubscriptionSubscription = { __typename?: 'Subscription', feedRecommendationSubscription: { __typename?: 'FeedAlarmSubscriptionPayload', feedTitle: string, studyActivityInstanceId: string, studyModuleInstanceId: string, studyUnitInstanceId: string } };


export const FeedRecommendationSubscriptionDocument = gql`
    subscription FeedRecommendationSubscription($studentId: ID!) {
  feedRecommendationSubscription(studentId: $studentId) {
    feedTitle
    studyActivityInstanceId
    studyModuleInstanceId
    studyUnitInstanceId
  }
}
    `;

/**
 * __useFeedRecommendationSubscriptionSubscription__
 *
 * To run a query within a React component, call `useFeedRecommendationSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useFeedRecommendationSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedRecommendationSubscriptionSubscription({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useFeedRecommendationSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<FeedRecommendationSubscriptionSubscription, FeedRecommendationSubscriptionSubscriptionVariables> & ({ variables: FeedRecommendationSubscriptionSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<FeedRecommendationSubscriptionSubscription, FeedRecommendationSubscriptionSubscriptionVariables>(FeedRecommendationSubscriptionDocument, options);
      }
export type FeedRecommendationSubscriptionSubscriptionHookResult = ReturnType<typeof useFeedRecommendationSubscriptionSubscription>;
export type FeedRecommendationSubscriptionSubscriptionResult = Apollo.SubscriptionResult<FeedRecommendationSubscriptionSubscription>;
export const namedOperations = {
  Subscription: {
    FeedRecommendationSubscription: 'FeedRecommendationSubscription'
  }
}